import { type UserSubscription } from '@cx-sdk/subs';

export const CX_LOGIN_SUCCESS = 'CX::LOGIN::SUCCESS';

export interface CXLoginSuccessEvent extends CustomEvent {
	detail: {
		deviceId: string;
		subscriptions: UserSubscription[];
		success: boolean;
		token: string;
		userId: string;
	};
}
